import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------
declare module '@mui/material/styles' {
  // text의 타입 TypeText 확장
  interface TypeText {
    light?: string;
  }

  interface Palette {
    text: TypeText;
  }

  interface PaletteOptions {
    text?: Partial<TypeText>; // Optional로 정의
  }

  interface Palette {
    navBackgrounColor: string;
  }
  interface PaletteOptions {
    navBackgrounColor?: string; // 선택적으로 확장
  }
}
export type ColorSchema = 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

declare module '@mui/material/styles/createPalette' {
  interface TypeBackground {
    neutral: string;
  }
  interface SimplePaletteColorOptions {
    lighter: string;
    darker: string;
  }
  interface PaletteColor {
    lighter: string;
    darker: string;
  }
}

// SETUP COLORS

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: '#AFC4E5',
  light: '#799FD9',
  main: '#5672D6',
  dark: '#354AA6',
  darker: '#1D2E86',
  contrastText: '#fff',
};
const SECONDARY = {
  lighter: '#D0D5EE',
  light: '#A3A8E5',
  main: '#6E74D9',
  dark: '#4A51A6',
  darker: '#2B307A',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D7F5FE',
  light: '#9EE2FD',
  main: '#62C8FA',
  dark: '#3694C4',
  darker: '#22638E',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E2F3EB',
  light: '#B6E1CE',
  main: '#68B894',
  dark: '#3C8B68',
  darker: '#235642',
  contrastText: '#fff',
};

const WARNING = {
  lighter: '#FFF4CC',
  light: '#FFE08E',
  main: '#FFC241',
  dark: '#B5882B',
  darker: '#6E5818',
  contrastText: '#fff',
};

const ERROR = {
  lighter: '#FDE1E1',
  light: '#F89B9B',
  main: '#F25A5A',
  dark: '#B84040',
  darker: '#7D2929',
  contrastText: '#fff',
};

const COMMON = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default function palette(themeMode: 'light' | 'dark') {
  const light = {
    ...COMMON,
    mode: 'light',
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
      light: GREY[100],
    },
    background: { paper: '#fff', default: '#fff', neutral: GREY[200] },
    action: {
      ...COMMON.action,
      active: GREY[600],
    },
    navBackgrounColor: '#212B36',
  } as const;

  const dark = {
    ...COMMON,
    mode: 'dark',
    text: {
      primary: '#fff',
      secondary: GREY[500],
      disabled: GREY[600],
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: alpha(GREY[500], 0.16),
    },
    action: {
      ...COMMON.action,
      active: GREY[500],
    },
  } as const;

  return themeMode === 'light' ? light : dark;
}
